/**
 * Widget Entry Point
 * Este archivo es el punto de entrada del widget embebible.
 * Se compila a public/widget.js con: npm run build-widget
 *
 * Uso en el sitio del cliente:
 * <script src="https://tuapp.com/widget.js" data-agent-id="UUID_DEL_AGENTE"></script>
 */

import { initWidget } from './ui'

// IMPORTANTE: capturar el elemento del script de forma SÍNCRONA.
// document.currentScript es null en callbacks async / DOMContentLoaded.
const currentScript = document.currentScript as HTMLScriptElement | null
const agentId = currentScript?.getAttribute('data-agent-id') ?? null

// Deriving apiBase from script src here so it's always available
const apiBase = (() => {
  try {
    return new URL(currentScript?.src ?? '').origin
  } catch {
    return window.location.origin
  }
})()

if (!agentId) {
  console.error('[ChatWidget] Missing data-agent-id attribute on script tag.')
} else {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWidget(agentId, apiBase))
  } else {
    initWidget(agentId, apiBase)
  }
}
